module.exports = __webpack_public_path__ + "static/media/upload.e05eb5da.png";